<template>
    <!--まとめ買い割引情報パーツ-->
    <div class="sh062" id="sh062">
        <loading :active.sync="isLoading" 
            :can-cancel="false"
            :background-color="'transparent'">
        </loading>

        <div class="sh062-title">
            <h2>{{dataInit.title}}</h2>
        </div>
        <div class="sh062-inner">
            <!--まとめ買い割引情報 -->
            <div class="sh062-detail" >
                <h4>{{dataInit.detail}}</h4>
            </div>
            <!--商品情報 -->
            <div class="sh062-item">
                <li v-for="(product, index) in dataInit.productList" :key="index">
                    <div v-if="product.S_ITEM_CD != null" class="sh062-gridLink" >
                        <!--商品詳細遷移領域-->
                        <a class ="link" @click="doDetail(product.S_ITEM_CD)">
                            <!--商品画像-->
                            <img class="productImage" :src="product.IMG_URL1" :alt="product.THUMBNAIL_DETAIL" @error="getErrImage" >
                        </a>
                        <template class ="sh062-link" >
                            <a class ="link" @click="doDetail(product.S_ITEM_CD)">
                                <div class="productContainer">
                                    <!--商品名＋キャッチコピー -->
                                    <span class="itemListDetail" >
                                        <strong >
                                            {{product.WEB_ITEM_NM}}
                                        </strong>
                                    </span>
                                </div>
                                <!-- 発売日 -->
                                <div class="releaseDate" v-if="product.YOYAKU_ITEM_FLG == 1">
                                    {{$t('pt110.labels.releaseDate')}}: {{stringNvl(product.SELL_YMD,'')}}
                                </div>
                                <div class="priceContainer">
                                    <!--通常商品-->
                                    <template v-if="(product.POINT_ITEM_KBN == '0' || product.POINT_ITEM_KBN == '2') && (dataInit.siteKbn == '4' && !dataInit.loginKbn) == false">
                                        <!--税込金額 -->
                                        <span v-if="product.ZEI_SET_KBN == '1'">
                                            {{$t('common.labels.price')}}：
                                            <span class="generalPrice">
                                                {{formatPrice(product.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
                                            </span>
                                        </span>
                                        <!--税抜金額 -->
                                        <span v-else>
                                            {{$t('common.labels.price')}}：
                                            <span class="generalPrice">
                                                {{formatPrice(product.SALE_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
                                            </span>
                                        </span>
                                        <template v-if="product.ITEM_ZEI_SET_KBN != '0'">
                                            <!-- (税込) -->
                                            <span class="priceTax" v-if="product.ZEI_SET_KBN == '1'">{{$t('common.labels.taxincluded')}}</span>
                                            <!-- (税抜) -->
                                            <span class="priceTax" v-else>{{$t('common.labels.excludingtax')}}</span>
                                        </template>
                                        <!--値引価格 -->
                                        <template v-if="(product.NEIBIKI_ZEI_K_TNK > 0 && ((product.ZEI_SET_KBN == '1' && product.NEIBIKI_ZEI_K_TNK != product.SALE_ZEI_K_TNK) || (product.ZEI_SET_KBN != '1' && product.NEIBIKI_ZEI_K_TNK != product.SALE_TNK)))">
                                            <!--値引価格 -->
                                            <template>
                                                <br>
                                                {{$t('common.labels.nebikiPrice')}}：
                                                <span class="nebikiPrice">
                                                    {{formatPrice(product.NEIBIKI_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}&nbsp;
                                                </span>
                                            </template>
                                            <template v-if="product.ITEM_ZEI_SET_KBN != '0'">
                                                <!-- (税込) -->
                                                <span class="priceTax" v-if="product.ZEI_SET_KBN == '1'">{{$t('common.labels.taxincluded')}}</span>
                                                <!-- (税抜) -->
                                                <span class="priceTax" v-else>{{$t('common.labels.excludingtax')}}</span>
                                            </template>
                                        </template>
                                        <!--ポイント付与 -->
                                        <template v-if="(product.POINT_NUM > 0)">
                                            <br>
                                            <span class="pointNum">
                                                {{formatPrice(product.POINT_NUM)}}{{$t('common.labels.pointGrantNum')}}
                                            </span>
                                        </template>
                                        <br/>
                                    </template>
                                    <!--ポイント交換商品-->
                                    <template v-if="product.POINT_ITEM_KBN == '1' || product.POINT_ITEM_KBN == '2'">
                                        <span class="price">
                                            {{formatPrice(product.POINT_ITEM_NUM)}}{{$t('common.labels.pt')}}
                                        </span>
                                    </template>
                                </div>
                                
                                <template v-if="product.HANBAI_FLG == 1">
                                    <template v-if="(product.ZAIKO_DISP_PLACE_KBN== '0' || product.ZAIKO_DISP_PLACE_KBN == '1') && product.ZAIKO_DISP_WAY_KBN !='0'">
                                        <div class="zaikoInfo">
                                            <!--在庫数表示、両方表示の場合 -->
                                            <template v-if="product.ZAIKO_DISP_WAY_KBN == '2' || product.ZAIKO_DISP_WAY_KBN == '3'">
                                                <!-- 在庫数 -->
                                                <span class="zaikoQty">{{$t('pt120.labels.numberOfStock')}}：{{formatPrice(product.ZAIKO_QTY)}}</span>
                                            </template>
                                            <!-- 在庫状態表示、両方表示の場合 -->
                                            <template v-if="product.ZAIKO_DISP_WAY_KBN == '1' || product.ZAIKO_DISP_WAY_KBN == '3'">
                                                <template v-if="product.ZAIKO_DISP_WAY_KBN == '3'"><br></template>
                                                <!-- 在庫なし-->
                                                <template v-if="product.ZAIKO_QTY <= 0">
                                                    <span class="zaikoMsg" v-if="product.ZAIKO_MSG3 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.none')}}</span>
                                                    <span class="zaikoMsg" v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG3}}</span>
                                                </template>
                                                <!-- 残りわずか -->
                                                <template v-else-if="product.ZAIKO_QTY > 0 && product.ZAIKO_QTY <= product.ZAIKO_CNT">
                                                    <span class="zaikoMsg" v-if="product.ZAIKO_MSG2 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.onlyFewRemaining')}}</span>
                                                    <span class="zaikoMsg" v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG2}}</span>
                                                </template>
                                                <template v-else-if="product.ZAIKO_QTY > product.ZAIKO_CNT">
                                                    <!-- あり -->
                                                    <span class="zaikoMsg" v-if="product.ZAIKO_MSG1 == null">{{$t('pt110.labels.stock')}}：{{$t('pt110.labels.there')}}</span>
                                                    <span class="zaikoMsg" v-else>{{$t('pt110.labels.stock')}}：&nbsp;{{product.ZAIKO_MSG1}}</span>
                                                </template>
                                            </template>
                                        </div>
                                    </template>
                                </template>
                                <div class="sh062-toyakiContainer">
                                    <template v-if="icon_flg1(product) != ''">
                                        <span class="itemIcon01">
                                            <font class="itemIconStar01" color="gold" style="font-size:11px;">★</font>
                                            <font class="itemIconNm01" color="#ff0033" style="font-size:11px;">{{icon_flg1(product)}}</font>
                                        </span>
                                    </template>
                                    <template v-if="icon_flg2(product) != ''">
                                        <span class="itemIcon02">
                                            <font class="itemIconStar02" color="gold" style="font-size:11px;">★</font>
                                            <font class="itemIconNm02" color="#ff0033" style="font-size:11px;">{{icon_flg2(product)}}</font>
                                        </span>
                                    </template>
                                    <template v-if="icon_flg3(product) != ''">
                                        <span class="itemIcon03">
                                            <font class="itemIconStar03" color="gold" style="font-size:11px;">★</font>
                                            <font class="itemIconNm03" color="#ff0033" style="font-size:11px;">{{icon_flg3(product)}}</font>
                                        </span>
                                    </template>
                                </div>
                                <br>
                                <div v-for="(kbnMap, indx) in dataInit.uketoriServiceKbnList" :key="indx" v-bind:class="'sh062-uketoriServiceInfo'+indx">
                                    <template v-if="kbnMap.UKETORI_SERVICE_KBN == '3' && product.CONVENI_UKE_FLG =='1'">
                                        <span class="yuubinNomal">
                                            <font color="gold" style="font-size:11px;">★</font>
                                            <font color="#ff0033" style="font-size:11px;">{{dataInit.uketoriServiceKbn[0].MARK_NM}}可</font>
                                        </span>
                                    </template>
                                    <template v-if="kbnMap.UKETORI_SERVICE_KBN == '4' && product.YUUBINKYOKU_UKE_FLG =='1'">
                                        <span class="yuubinJp">
                                            <font color="gold" style="font-size:11px;">★</font><font color="#ff0033" style="font-size:11px;">
                                                {{dataInit.uketoriServiceKbn[1].MARK_NM}}可
                                            </font>
                                            <img width="25" height="25" src="<%=Constants.DOC_ROOT %>/img/jp_logo.gif" alt="郵便局窓口受取">
                                        </span>
                                    </template>
                                    <template v-if="kbnMap.UKETORI_SERVICE_KBN == '5' && product.HAKOPOST_UKE_FLG =='1'">
                                        <span class="yuubinHako">
                                            <font color="gold" style="font-size:11px;">★</font>
                                            <font color="#ff0033" style="font-size:11px;">{{dataInit.uketoriServiceKbn[2].MARK_NM}}可</font>
                                            <img width="25" height="25" src="<%=Constants.DOC_ROOT %>/img/jp_hako_logo.gif" alt="はこぽす">
                                        </span>
                                    </template>
                                </div>
                            </a>
                        </template><!--商品詳細遷移領域ここまで-->
                    </div>
                </li>
            </div>

            <div class="sh062-Submit-row">
                <!-- 前のページへ戻る -->
                <button @click="gotobak" type="button">{{$t("common.buttons.backtothepreviouspage")}}</button>
            </div>
        </div>
        
        <!--メッセージ表示するため、入れるもの -->
        <div hidden>
            <span id="allFlg_lbl" >{{$t('sh062.labels.allFlg')}}</span>
            <span id="compSyubetuNm_lbl" >{{$t('sh062.labels.compSyubetuNm')}}</span>
            <span id="messageContents_lbl" >{{$t('sh062.labels.messageContents')}}</span>
        </div>
    </div>
</template>
<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import Loading from 'vue-loading-overlay';
import InputCheck from "components/InputCheck";
import AlertConfirm from "components/AlertConfirm";
import EventBus from "assets/js/eventBus";
import SiteConstants from 'assets/const/SiteConstants.json';
import Message from 'components/MessageEcSite';

export default {
    /* 
    * Name of component
    */
    name: "SH062ShopperMatomeItemInfo",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /* 
    * Declare components
    */
    components: {
        InputCheck,
        Loading,
        AlertConfirm,
        Message
    },/* 
    * Declare variable and set default value
    */
    data() {
        return {
            dataInit:{},
            reqModel:{
                matomeCd: null
            },
            SiteConstants: SiteConstants,
            common:common,
            isLoading: false
        }
    },
    /* 
    * Initialize
    */
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        if (_this.ptInitData){
            _this.isLoading = true;
            try {
                _this.dataInit = _this.ptInitData;
                _this.reqModel = Object.assign({}, _this.reqModel, _this.ptInitData.reqModel);
                _this.$forceUpdate();
            } catch (error) {
                common.errorAPI(error);
            }finally{
                _this.isLoading = false;
            }
        }else{
            _this.isLoading = true;
            var reqModel = {
                matomeCd:this.reqModel.matomeCd}
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.sh062 + _this.$UrlConstants.DO_INIT,reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.dataInit = response.data;
                    _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModel);
                }
                
                _this.$forceUpdate();
                _this.isLoading = false;
            }).catch(function(error) {
                _this.isLoading = false;
                common.errorAPI(error);
            });
        }

        EventBus.$on("closed", function() {

        });

    },
    /* 
    * Methods
    */
    methods: {
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
         getErrImage(event) {
            //get image default
            console.log('getErrImage='+event);
            event.target.src = common.getImgDefault();
            console.log('event.target.src='+common.getImgDefault());
        },
        //前画面に戻る
        gotobak:function(){
            var _this = this;
            //_this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: _this.dataInit.backPageNo}});
            this.$router.go(-1);
        },
        /*
        * 商品詳細画面へ遷移
        */
        doDetail: function(sItemNo){
            var _this = this;
            _this.$emit("event-loading", true);
            _this.$router.push({ name: SiteConstants.PG030, params :{pageNo: 3, sItemNo: sItemNo}});
        },
        icon_flg1: function(product){
            if(product.ITEM_STATUS1 == '0'){
                return product.ICON_NM1;
            } else {
                return "";
            }
        },
        icon_flg2: function(product){
            if(product.ITEM_STATUS2 == '0'){
                return product.ICON_NM2;
            } else {
                return "";
            }
        },
        icon_flg3: function(product){
            if(product.ITEM_STATUS3 == '0'){
                return product.ICON_NM3;
            } else {
                return "";
            }
        },
        formatPrice: function(value){
            return common.formatPrice(value);
        },
    },
}
</script>

